<template>
  <div
      :style="style"
      class="popover">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'BasePopover',
  computed: {
    style() {
      return {
        left: `${this.x}px`,
        top: `${this.y}px`,
        visibility: this.visible ? 'visible' : 'hidden',
      };
    },
  },
  data() {
    return {
      x: -1000,
      y: -1000,
      visible: false,
    };
  },
  props: {
    target: Object,
  },
  methods: {
    onDocumentClick() {
      this.visible = false;
      document.removeEventListener('click', this.onDocumentClick, false);
    },
    toggle(event) {
      event.stopPropagation();

      // Close if already opened
      if (this.visible) {
        this.visible = false;
        return;
      }

      // Make sure we have the DOM element and not a Vue component
      let { target } = this;
      if (target.$el) {
        target = target.$el;
      }

      // Calculate position
      // TODO: Update position on window resize
      const targetBoundingClientRect = target.getBoundingClientRect();
      const targetX = targetBoundingClientRect.x;
      const targetY = targetBoundingClientRect.y;

      const targetWidth = target.offsetWidth;
      const targetHeight = target.offsetHeight;

      const popoverWidth = this.$el.offsetWidth;
      const popoverHeight = this.$el.offsetHeight;

      if (targetX + popoverWidth > window.innerWidth) {
        this.x = targetX + targetWidth - popoverWidth;
      } else {
        this.x = targetX;
      }

      if (targetY + targetHeight + popoverHeight > window.innerHeight) {
        this.y = targetY - targetHeight - popoverHeight;
      } else {
        this.y = targetY + targetHeight;
      }

      this.visible = true;

      document.addEventListener('click', this.onDocumentClick, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.popover {
  position: fixed;
}
</style>
